module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    attrs: {
      "label-width": "110px"
    }
  }, [_c('div', {
    staticClass: "m-b-10"
  }, [_vm._v("功能集布局配置")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "展示方式"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.show_type),
      expression: "form.show_type"
    }],
    domProps: {
      "value": (_vm.form.show_type)
    },
    on: {
      "input": function($event) {
        _vm.form.show_type = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 10
    }
  }, [_vm._v("一般")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 20
    }
  }, [_vm._v("Tab")])])]), _vm._v(" "), _vm._l((_vm.form.arr), function(item, index) {
    return _c('div', {
      staticClass: "m-b-10 bor-b-ccc"
    }, [_c('el-form-item', {
      attrs: {
        "label": "一级功能集"
      }
    }, [_c('el-select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.content_id),
        expression: "item.content_id"
      }],
      domProps: {
        "value": (item.content_id)
      },
      on: {
        "input": function($event) {
          item.content_id = $event
        }
      }
    }, _vm._l((_vm.contents), function(option) {
      return _c('el-option', {
        attrs: {
          "label": option.name,
          "value": option.id
        }
      })
    }))]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "绑定权限规则"
      }
    }, [_c('el-input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (item.rule_name),
        expression: "item.rule_name",
        modifiers: {
          "trim": true
        }
      }],
      staticClass: "h-40 fl w-150 m-r-10",
      attrs: {
        "disabled": true,
        "placeholder": "绑定权限规则"
      },
      domProps: {
        "value": (item.rule_name)
      },
      on: {
        "input": function($event) {
          item.rule_name = (typeof $event === 'string' ? $event.trim() : $event)
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('el-button', {
      staticClass: "fl",
      attrs: {
        "size": "small"
      },
      on: {
        "click": function($event) {
          _vm.openRule(item)
        }
      }
    }, [_vm._v("查找")]), _vm._v(" "), _c('el-button', {
      staticClass: "fl m-l-5",
      attrs: {
        "size": "small"
      },
      on: {
        "click": function($event) {
          _vm.clearRule(item)
        }
      }
    }, [_vm._v("清空")])]), _vm._v(" "), (_vm.form.show_type == 20 && _vm.form.arr.length > 1) ? _c('el-form-item', [_c('el-button', {
      attrs: {
        "size": "small",
        "type": "primary",
        "disabled": index == 0
      },
      on: {
        "click": function($event) {
          _vm.sortUp(index)
        }
      }
    }, [_vm._v("上移")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "size": "small",
        "type": "primary",
        "disabled": index == _vm.form.arr.length - 1
      },
      on: {
        "click": function($event) {
          _vm.sortDown(index)
        }
      }
    }, [_vm._v("下移")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "size": "small"
      },
      on: {
        "click": function($event) {
          _vm.deleteContent(index)
        }
      }
    }, [_vm._v("删除")])]) : _vm._e()])
  }), _vm._v(" "), _c('el-form-item', [(_vm.form.show_type == 20) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addContent
    }
  }, [_vm._v("添加一个")]) : _vm._e()])], true)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4719896e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content/abstract/contentForm.vue
// module id = 1846
// module chunks = 2